import { Clock } from "lucide-react";
import { daysOnMarketLabel } from "@/lib/format";

/**
 * DOMBadge — small inline pill showing "Today" / "1 day" / "N days on market".
 * Used on Listing + Requirement cards.
 */
export function DOMBadge({ createdAt, testId }) {
  const label = daysOnMarketLabel(createdAt);
  return (
    <span
      className="inline-flex items-center gap-1 rounded-full border border-gray-200 bg-white px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider text-gray-500"
      data-testid={testId}
    >
      <Clock className="h-3 w-3" />
      {label} on market
    </span>
  );
}
